import config from 'config';

import { ProductType } from '~/techstyle-shared/react-products';

import { getAvailableProductQuantity } from './getAvailableProductQuantity';
import { isSoldOut } from './isSoldOut';

const locationLowStockIndicator = config.get(
  'public.quantityRules.locationLowStockIndicator'
);

export const isLowStock = ({ product, region, thresholdOverride }) => {
  if (
    !product ||
    product.productTypeId === ProductType.BUNDLE ||
    isSoldOut({ product })
  ) {
    return false;
  }

  const availableProductQuantity = getAvailableProductQuantity(product);
  const lowStockRules = locationLowStockIndicator.masterProduct[region];
  const lowStockThreshold = thresholdOverride || lowStockRules.lowStockMax;

  return (
    availableProductQuantity <= lowStockThreshold &&
    availableProductQuantity > lowStockRules.criticalStockMax
  );
};
